import logo from '@assets/images/woah_logo_white.png';
import Constants from 'expo-constants';
import { Image, SizableText, XStack, YStack, useTheme } from 'tamagui';

export default function NavigationHeader(): React.ReactNode {
  const theme = useTheme();
  const appName = Constants.expoConfig?.name ?? 'WildEpi';

  return (
    <XStack alignItems="center" gap="$3" paddingHorizontal="$3">
      <Image source={logo} width={35} height={35} />
      <YStack width={1} height={20} backgroundColor={theme.background?.val} />
      <SizableText
        color={theme.background?.val}
        fontSize="$1"
        fontFamily="$bold"
      >
        {appName}
      </SizableText>
    </XStack>
  );
}
